@import 'abstract/colors';
@import 'abstract/variables';
// Commented for future promos
//@import url('https://fonts.googleapis.com/css2?family=Palanquin+Dark:wght@400;500;600;700&display=swap');

/* latin-ext */
/*
@font-face {
  font-family: 'Rammetto One';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/assets/fonts/rammetto-one-latin/RammettoOneLatinExt.woff2') format('woff2');
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
*/

/* latin */
/*
@font-face {
  font-family: 'Rammetto One';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/assets/fonts/rammetto-one-latin/RammettoOneLatin.woff2') format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
*/

/* It can be useful for future promos
.with-bg {
  background: $bg-promo;

  .header__promo {
    background: $bg-promo;
  }

  img {
    height: 60px;
  }
}
*/

.header__promo {
  width: 100%;
  background: $white;
  // font-family: "Palanquin Dark", sans-serif;
  font-family: Poppins, sans-serif;
  text-decoration: none;
  position: relative;
  //max-width: 1296px;
  margin: 0 auto;

  &-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: $white;
    white-space: nowrap;
    text-transform: uppercase;
    height: 100%;

    @include breakpoint(lg) {
      font-size: 12px;
      line-height: 15px;
    }

    .discount {
      display: flex;
      align-items: center;
      margin: 0 32px;
      line-height: 28px;
      text-align: center;

      @include breakpoint(lg) {
        display: flex;
        flex-direction: column;
        font-size: 12px;
        line-height: 12px;
        margin: 0 10px;
      }

      @include breakpoint(xs) {
        margin: 0 5px;
      }

      b {
        margin: 0 4px -2px 0;
        line-height: 28px;
        font-size: 28px;
        font-weight: 600;
        font-family: Roboto, sans-serif;

        @include breakpoint(lg) {
          margin: 0;
          font-size: 20px;
          line-height: 17px;
        }
      }
    }
  }
}


// Temp styles for 2024 autumn-winter promotions
header-promo {
  background-color: $black;
  display: block;
  overflow: hidden;
}

.header__promo {
  background: radial-gradient(circle, #2764c0 0%, #143768 100%);
  overflow: hidden;
  height: 60px;

  @include breakpoint(lg) {
    height: 40px;
  }

  &-text {
    z-index: 1;
    animation: slide 7s infinite;
    padding: 0;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0; // Side image width. This is constant
    width: 392px;
    height: 60px;
    background: url(/assets/img/header-promo/header-promo-left-side-desktop.png) center/contain no-repeat;

    @include breakpoint(xlg) {
      left: -220px;
    }

    @include breakpoint(lg) {
      background-image: url(/assets/img/header-promo/header-promo-left-side-mobile.png);
      width: 70px;
      height: 40px;
      left: -16px;
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 392px;
    height: 60px;
    background: url(/assets/img/header-promo/header-promo-right-side-desktop.png) center/contain no-repeat;

    @include breakpoint(xlg) {
      right: -220px;
    }

    @include breakpoint(lg) {
      background-image: url(/assets/img/header-promo/header-promo-right-side-mobile.png);
      width: 70px;
      height: 40px;
      right: -16px;
    }
  }

  .discount-size {
    font-size: 30px;

    @include breakpoint(lg) {
      font-size: 18px;
    }
  }

  @keyframes slide {
    0% {
      transform: translateY(0);
    }
    42% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-100%);
    }
    92% {
      transform: translateY(-100%);
    }
    100% {
      transform: translateY(0);
    }
  }

  /*
  .discount-label {
    display: flex;
    align-items: center;

    @include breakpoint(lg) {
      flex-direction: column;
    }
  }

  .discount-size {
    margin-right: 8px;
    font-size: 36px;
    line-height: 36px;
    font-weight: 600;
  }

  @include breakpoint(lg) {
    .discount-size {
      font-size: 20px;
      line-height: 20px;
      margin-right: 4px;
    }

    .discount-text {
      font-size: 9px;
    }

    &.de, &.ch, &.nl {
      .header__promo-text {
        padding: 4px 65px;

        .title-right, .discount-description {
          font-size: 9px;
          line-height: 9px;
        }
      }
    }

    &.pt {
      .header__promo-text {
        padding: 4px 61px;

        .title-right, .discount-description {
          font-size: 8px;
          line-height: 8px;
        }
      }
    }

    &.se {
      .header__promo-text {
        padding: 4px 61px;
        grid-column-gap: 4px;

        .title-right, .discount-description {
          font-size: 8px;
          line-height: 8px;
        }

        .title-left {
          font-size: 12px;
        }
      }
    }

    &.dk {
      .header__promo-text {
        padding: 4px 56px;
        grid-column-gap: 4px;

        .title-right, .discount-description {
          font-size: 8px;
          line-height: 8px;
        }

        .title-left {
          font-size: 11px;
        }
      }
    }
  }
  */
}
